import { useMemo } from "react";

import { useStore } from "@/store";
import { docPageUrl, teamPageUrl } from "@/urls";
import { getFirstDocumentOfTeam } from "@/utils/getFirstDocumentOfTeam";
import { getLastDocIdForTeam } from "@/utils/useLastDocId";

export function useLastDocForCurrentTeamUrl() {
  const { documentTree } = useStore();

  const url = useMemo(() => {
    const lastDocId = getLastDocIdForTeam(documentTree.team?.uid || "");
    const firstDocument = getFirstDocumentOfTeam(documentTree.team);

    if (lastDocId || firstDocument) {
      return docPageUrl({ docId: lastDocId || firstDocument?.uid || "" });
    }

    return teamPageUrl({ teamPermalink: documentTree.team?.permalink || "doc" });
  }, [documentTree.team]);

  return url;
}
